import { Component } from 'react';
import type { ReactNode, ErrorInfo } from 'react';
import { Text, Stack } from '@7shifts/sous-chef-base';

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(): State {
        return { hasError: true };
    }

    componentDidCatch(error: Error, info: ErrorInfo) {
        console.error('[ErrorBoundary]', error, info.componentStack);
    }

    render() {
        if (this.state.hasError) {
            return (
                <main
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flex: 1,
                        padding: 'var(--spacing-32)'
                    }}
                >
                    <Stack space={16} alignItems="center">
                        {/*
                         * Strings are intentionally hardcoded — ErrorBoundary must be a
                         * class component (React has no hook equivalent for
                         * getDerivedStateFromError / componentDidCatch), so useTranslation
                         * cannot be used here.
                         */}
                        <Text as="h1" alignment="center">
                            Something went wrong
                        </Text>
                        <Text
                            as="h4"
                            alignment="center"
                            color="var(--color-surface-on-color-subtle)"
                        >
                            Please reload the page or contact your manager if
                            the problem persists.
                        </Text>
                    </Stack>
                </main>
            );
        }

        return this.props.children;
    }
}
